export default __webpack_public_path__ + "static/lilnadas-cards-story-1-f697464e1672732817f1046625fcba8d.png";